module.exports = __webpack_public_path__ + "img/01040303.a7dbb291.png";